import {useState} from "react";
import AccounTransForm from "./AccountTranslationFormField";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

const UpdateAccountTrans = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/"},
        {content: "Account Translations", url: "/account-translations"},
        {content: "Update Account Translations", url: ""},
    ]);

    return (
        <>
            <AccounTransForm crumbs={crumbs} title={"Update Account Translations"} btnText={"Update"}
             isReadOnly={hasPermission(["ACCTRA-U"]) === false}/>
        </>

    )
}

export default UpdateAccountTrans;